<template>
  <div>
    <b-navbar toggleable="lg" type="light" variant="light">
      <b-navbar-brand to="/">Admin</b-navbar-brand>

      <b-collapse id="nav-text-collapse" is-nav>
        <b-navbar-nav>
          <b-nav-item v-if="permissions.articles || permissions.admin" to="/Artikel">
            Artikel
          </b-nav-item>


          <b-nav-item v-if="permissions.calendar || permissions.admin" to="/Termine">
            Kalender
          </b-nav-item>

          <b-nav-item v-if="permissions.warnings || permissions.admin" to="/Hinweise">
            Hinweise
          </b-nav-item>

          <b-nav-item v-if="permissions.cms || permissions.admin" to="/Navigation">Aufbau & Inhalt
          </b-nav-item>

          <b-nav-item v-if="permissions.excuses || permissions.admin" to="/Entschuldigungen">
            Entschuldigungen
          </b-nav-item>
          <b-nav-item v-if="permissions.quickaccess || permissions.admin" to="/Schnellzugriffe">
            Schnellzugriffe
          </b-nav-item>
          <b-nav-item v-if="permissions.permissions || permissions.admin" to="/Benutzer">Benutzer</b-nav-item>
        </b-navbar-nav>

        <b-navbar-nav class="ml-auto">
          <b-nav-item @click="help">
            <b-icon-question-circle variant="primary"></b-icon-question-circle>
          </b-nav-item>
          <b-nav-item @click="logout">
            <b-icon-power variant="danger"></b-icon-power>
            <span>Abmelden</span>
          </b-nav-item>
        </b-navbar-nav>

      </b-collapse>

      <b-navbar-toggle target="nav-text-collapse"></b-navbar-toggle>
    </b-navbar>
    <b-modal id="help" centered title="Kontakt">
      <div>Email: <a href="mailto:bartz@develop4future.de">Bartz@Develop4Future.de</a></div>
    </b-modal>
  </div>
</template>

<script>
import store from '@/store'
import {mapActions, mapGetters} from "vuex";
import {BIconPower, BIconQuestionCircle} from 'bootstrap-vue'

export default {
  name: 'Navbar',
  components: {
    BIconPower,
    BIconQuestionCircle
  },
  data() {
    return {
      main_url: process.env.VUE_APP_MAIN_URL
    }
  },
  methods: {
    ...mapActions([
      'getPermissions'
    ]),
    logout() {
      store.commit('clearAccessToken')
    },
    help() {
      this.$bvModal.show('help')
    }
  },
  computed: {
    ...mapGetters([
      'getStoredPermissions'
    ]),
    permissions() {
      return this.getStoredPermissions
    }
  },
  mounted() {
    this.getPermissions()
  }
}
</script>

<style>
hr {
  margin: 0;
}
</style>
